import { createMessageName } from '@formkit/validation';
import { sentence, date, order, list } from '../formatters.mjs';

// packages/i18n/src/locales/pl.ts
var add = "Dodaj";
var remove = "Usuń";
var removeAll = "Usuń wszystko";
var incomplete = "Nie wszystkie pola zostały wypełnione poprawnie.";
var submit = "Wyślij";
var noFiles = "Nie wybrano pliku";
var moveUp = "Przesuń w górę";
var moveDown = "Przesuń w dół";
var isLoading = "Ładowanie...";
var loadMore = "Załaduj więcej";
var next = "Kolejny";
var prev = "Poprzednia";
var addAllValues = "Dodaj wszystkie wartości";
var addSelectedValues = "Dodaj wybrane wartości";
var removeAllValues = "Usuń wszystkie wartości";
var removeSelectedValues = "Usuń wybrane wartości";
var chooseDate = "Wybierz datę";
var changeDate = "Zmień datę";
var close = "Zamknij";
var open = "Otwórz";
var accepted = function({
  name
}) {
  return `Proszę zaakceptować ${name}.`;
};
var date_after = function({
  name,
  args
}) {
  if (Array.isArray(args) && args.length) {
    return `${sentence(name)} musi być po ${date(args[0])}.`;
  }
  return `${sentence(name)} musi być w przyszłości.`;
};
var alpha = function({
  name
}) {
  return `Pole ${sentence(name)} może zawierać tylko znaki alfabetyczne.`;
};
var alphanumeric = function({
  name
}) {
  return `Pole ${sentence(name)} może zawierać tylko znaki alfanumeryczne.`;
};
var alpha_spaces = function({
  name
}) {
  return `Pole ${sentence(name)} mogą zawierać tylko litery i spacje.`;
};
var contains_alpha = function({
  name
}) {
  return `${sentence(name)} musi zawierać znaki alfabetyczne.`;
};
var contains_alphanumeric = function({
  name
}) {
  return `${sentence(name)} musi zawierać litery lub cyfry.`;
};
var contains_alpha_spaces = function({
  name
}) {
  return `${sentence(name)} musi zawierać litery lub spacje.`;
};
var contains_symbol = function({
  name
}) {
  return `${sentence(name)} musi zawierać symbol.`;
};
var contains_uppercase = function({
  name
}) {
  return `${sentence(name)} musi zawierać wielkie litery.`;
};
var contains_lowercase = function({
  name
}) {
  return `${sentence(name)} musi zawierać małe litery.`;
};
var contains_numeric = function({
  name
}) {
  return `${sentence(name)} musi zawierać liczby.`;
};
var symbol = function({
  name
}) {
  return `${sentence(name)} musi być symbolem.`;
};
var uppercase = function({
  name
}) {
  return `${sentence(name)} może zawierać tylko wielkie litery.`;
};
var lowercase = function({
  name
}) {
  return `${sentence(name)} może zawierać tylko małe litery.`;
};
var date_before = function({
  name,
  args
}) {
  if (Array.isArray(args) && args.length) {
    return `${sentence(name)} musi być przed ${date(args[0])}.`;
  }
  return `${sentence(name)} musi być w przeszłości.`;
};
var between = function({
  name,
  args
}) {
  if (isNaN(args[0]) || isNaN(args[1])) {
    return `Pole zostało wypełnione niepoprawnie i nie może zostać wysłane.`;
  }
  const [a, b] = order(args[0], args[1]);
  return `Wartość pola ${sentence(name)} musi być pomiędzy ${a} i ${b}.`;
};
var confirm = function({
  name
}) {
  return `${sentence(name)} nie pokrywa się.`;
};
var date_format = function({
  name,
  args
}) {
  if (Array.isArray(args) && args.length) {
    return `Wartość pola ${sentence(name)} nie jest poprawną datą, proszę użyć formatu ${args[0]}`;
  }
  return "To pole zostało wypełnione niepoprawnie i nie może zostać wysłane";
};
var date_between = function({
  name,
  args
}) {
  return `Data w polu ${sentence(name)} musi być pomiędzy ${date(args[0])} i ${date(args[1])}`;
};
var email = "Proszę wpisać poprawny adres email.";
var ends_with = function({
  name,
  args
}) {
  return `Pole ${sentence(name)} nie kończy się na ${list(args)}.`;
};
var is = function({
  name
}) {
  return `Pole ${sentence(name)} nie jest dozwoloną wartością.`;
};
var length = function({
  name,
  args: [first = 0, second = Infinity]
}) {
  const min2 = Number(first) <= Number(second) ? first : second;
  const max2 = Number(second) >= Number(first) ? second : first;
  if (min2 == 1 && max2 === Infinity) {
    return `Pole ${sentence(name)} musi posiadać minimum jeden znak.`;
  }
  if (min2 == 0 && max2) {
    return `Pole ${sentence(name)} musi zawierać ${max2} lub mniej znaków.`;
  }
  if (min2 && max2 === Infinity) {
    return `Pole ${sentence(name)} musi zawierać ${min2} lub więcej znaków.`;
  }
  if (min2 === max2) {
    return `Pole ${sentence(name)} musi mieć ${min2} znaków.`;
  }
  return `Pole ${sentence(name)} musi mieć ${min2}-${max2} znaków.`;
};
var matches = function({
  name
}) {
  return `Pole ${sentence(name)} zawiera niedozwolone znaki.`;
};
var max = function({
  name,
  node: {
    value
  },
  args
}) {
  if (Array.isArray(value)) {
    return `Nie można mieć więcej niż ${args[0]} ${name}.`;
  }
  return `Wartość pola ${sentence(name)} musi być mniejsza lub równa ${args[0]}.`;
};
var mime = function({
  name,
  args
}) {
  if (!args[0]) {
    return "Nie podano dozwolonych typów plików.";
  }
  return `${sentence(name)} musi być typem: ${args[0]}`;
};
var min = function({
  name,
  node: {
    value
  },
  args
}) {
  if (Array.isArray(value)) {
    return `Musisz podać więcej niż ${args[0]} ${name}.`;
  }
  return ` Musisz podać conajmniej ${args[0]} ${sentence(name)}.`;
};
var not = function({
  name
}) {
  return `Wartość pola ${name} jest niedozwolona.`;
};
var number = function({
  name
}) {
  return `${sentence(name)} musi być numerem.`;
};
var require_one = function({
  name,
  node,
  args: inputNames
}) {
  const labels = inputNames.map((name2) => {
    const dependentNode = node.at(name2);
    if (dependentNode) {
      return createMessageName(dependentNode);
    }
    return false;
  }).filter((name2) => !!name2);
  labels.unshift(name);
  return `${labels.join(" lub ")} wymagany jest.`;
};
var required = function({
  name
}) {
  return `Pole ${sentence(name)} jest wymagane.`;
};
var starts_with = function({
  name,
  args
}) {
  return `Wartośc pola ${sentence(name)} nie zaczyna się od ${list(args)}.`;
};
var url = function() {
  return `Wprowadź prawidłowy adres URL.`;
};
var invalidDate = "Wybrana data jest nieprawidłowa.";
var ui = {
  add,
  remove,
  removeAll,
  incomplete,
  submit,
  noFiles,
  moveUp,
  moveDown,
  isLoading,
  loadMore,
  next,
  prev,
  addAllValues,
  addSelectedValues,
  removeAllValues,
  removeSelectedValues,
  chooseDate,
  changeDate,
  close,
  open
};
var validation = {
  accepted,
  date_after,
  alpha,
  alphanumeric,
  alpha_spaces,
  contains_alpha,
  contains_alphanumeric,
  contains_alpha_spaces,
  contains_symbol,
  contains_uppercase,
  contains_lowercase,
  contains_numeric,
  symbol,
  uppercase,
  lowercase,
  date_before,
  between,
  confirm,
  date_format,
  date_between,
  email,
  ends_with,
  is,
  length,
  matches,
  max,
  mime,
  min,
  not,
  number,
  require_one,
  required,
  starts_with,
  url,
  invalidDate
};
var pl_default = {
  ui,
  validation
};

export { accepted, add, addAllValues, addSelectedValues, alpha, alpha_spaces, alphanumeric, between, changeDate, chooseDate, close, confirm, contains_alpha, contains_alpha_spaces, contains_alphanumeric, contains_lowercase, contains_numeric, contains_symbol, contains_uppercase, date_after, date_before, date_between, date_format, pl_default as default, email, ends_with, incomplete, invalidDate, is, isLoading, length, loadMore, lowercase, matches, max, mime, min, moveDown, moveUp, next, noFiles, not, number, open, prev, remove, removeAll, removeAllValues, removeSelectedValues, require_one, required, starts_with, submit, symbol, uppercase, url };
//# sourceMappingURL=out.js.map
//# sourceMappingURL=pl.mjs.map